export const LEARN_MORE_SECTION = [
  {
    title: "行业研究与洞见",
    description: "与 PingCAP 行业专家一起研究与探索技术与行业创新之道",
    link: {
      label: "查看详情",
      value: "/insight",
    },
  },
  {
    title: "了解 TiDB 的最佳实践",
    description:
      "TiDB 最佳实践是基于众多客户的成功案例萃取而成的最优化数据库转型指导，每个最佳实践包括使用场景、部署方案及业务收益。从业务的角度，描述了 TiDB 为各行各业用户带来的业务价值。",
    link: {
      label: "查看详情",
      value: "/practice",
    },
  },
]
